import React from "react";
import { Outlet } from "react-router-dom";
import OrderSidebar from "./sidebar";

const RestaurantOrderManagementLayout = () => {
  return (
    <>
      <div>
        <OrderSidebar />
        <Outlet />
      </div>
    </>
  );
};

export default RestaurantOrderManagementLayout;
